module.exports = __webpack_public_path__ + "img/mex.af4bd37a.jpeg";